module.exports = __webpack_public_path__ + "static/media/BehanceIcon.5bf76d19.svg";